export const BATTERIES_API = '/api/v1/batteries';
